<swiper id="cases-swiper" [config]="swiperConfigService.swiperFilhoConfig" (indexChange)="onSlideIndexChange($event)">
    <div class="swiper-slide">
        <app-cases-page1></app-cases-page1>
    </div>
    <!--<div class="swiper-slide">
        <app-cases-page2 #casesPage2 (openPortfolioOutput)="openPortfolioEvent($event)"></app-cases-page2>
    </div>-->
</swiper>